import React, { useState, useEffect } from 'react';

import { SomaIcon } from "@soma/react";
import { SomaTooltip } from "@soma/react";

import Select from 'xpi-black-ui/Base/Select';
import Button from 'xpi-black-ui/Base/Button';
import { Row, Col } from 'xpi-black-ui/Base/Grid';
import { P } from  'xpi-black-ui/Base/Typography';
import { SingleDatePicker, DateRangePicker } from 'xpi-black-ui/Common/DatePicker';

import { Container } from './styles';

import waConfig from 'utils/waConfig';
import { disableDayBiggerOndeYear } from 'utils/helpers';

function Header({ assets, strategies, addToConfiguration }) {
  const [asset, setAsset] = useState(null);
  const [reverse, setReverse] = useState(null);
  const [buyAsset, setBuyAsset] = useState(null);
  const [structure, setStructure] = useState(null);
  const [maturityDate, setMaturityDate] = useState(undefined);
  const [maturityDateReverse, setMaturityDateReverse] = useState(undefined);
  const [diabledBuyAsset, setDiabledBuyAsset] = useState(false);
  const [isFormHeaderValid, setIsFormHeaderValid] = useState(false);

  const yesOrNo = [
    { label: 'Sim', value: true },
    { label: 'Não', value: false },
  ];

  useEffect(() => {
    let allFieldsSet = Boolean(asset) && Boolean(structure) && buyAsset !== null && reverse !== null && maturityDate;

    if (reverse) {
      allFieldsSet = maturityDateReverse && allFieldsSet;
    }

    setIsFormHeaderValid(allFieldsSet);
  }, [asset, structure, maturityDate, buyAsset, reverse, maturityDateReverse]);

  const cleanHeader = () => {
    setAsset(null);
    setReverse(null);
    setBuyAsset(null);
    setStructure(null);
    setMaturityDate(undefined);
    setMaturityDateReverse(undefined);
  };

  const addStructure = () => {
    cleanHeader();
    addToConfiguration({
      asset: asset.value, structure: structure.idEstruturaNome, maturityDate, maturityDateReverse, buyAsset, reverse, edit: false
    });
  };

  const onChangeStructure = (structureSelected) => {
    setStructure(structureSelected);

    const { compraAtivo } = structureSelected;

    const hasDisableSelectBuyAsset = !compraAtivo;
    const optionBuyAsset = !compraAtivo ? yesOrNo[1].value : buyAsset;

    setBuyAsset(optionBuyAsset);
    setDiabledBuyAsset(hasDisableSelectBuyAsset);
  };

  const onRangeDatesChange = dates => {
    const { startDate, endDate } = dates;
    if (startDate) { setMaturityDate(startDate) }
    if (endDate) { setMaturityDateReverse(endDate) }
  };

  return (
    <Container>
      <Row className="header-item" justifyContent="space-between">
        <Col>
          <SomaTooltip
            inverse
            position="top"
            aria-label="Ativo"
            style={{ display: 'flex', width: 'fit-content' }}
            label="As cotações estão disponíveis para Ações Nacionais e ETFs de opções não exóticas."
          >
            <P>Ativo</P>
            <SomaIcon icon="info" size="sm" color="#FFC709" />
          </SomaTooltip>
          <Select
            value={asset}
            options={assets}
            placeholder="Selecione"
            onChange={value => setAsset(value)}
            noOptionsMessage={() => ('Ativo não encontrado')}
          />
        </Col>

        <Col>
          <P>Estrutura</P>
          <Select
            value={structure}
            options={strategies}
            placeholder="Selecione"
            onChange={value => onChangeStructure(value)}
            noOptionsMessage={() => ('Estrutura não encontrada')}
          />
        </Col>

        <Col>
          <P>Compra do ativo</P>
          <Select
            options={yesOrNo}
            placeholder="Selecione"
            isDisabled={diabledBuyAsset}
            onChange={e => setBuyAsset(e.value)}
            noOptionsMessage={() => ('Opção não encontrada')}
            value={yesOrNo.find(type => type.value === buyAsset) || null}
          />
        </Col>

        <Col>
          <SomaTooltip
            inverse
            position="top"
            aria-label="Ativo"
            style={{ display: 'flex', width: 'fit-content' }}
            label="Em caso de rolagem, entende-se que haverá a venda e a compra da estrutura."
          >
            <P>Rolagem</P>
            <SomaIcon icon="info" size="sm" color="#FFC709" />
          </SomaTooltip>
          <Select
            options={yesOrNo}
            placeholder="Selecione"
            onChange={e => setReverse(e.value)}
            noOptionsMessage={() => ('Opção não encontrada')}
            value={yesOrNo.find(type => type.value === reverse) || null}
          />
        </Col>

        <Col>
          <SomaTooltip
            inverse
            position="top"
            aria-label="Vencimento"
            style={{ display: 'flex', width: 'fit-content' }}
            label="O período máximo disponível para cotação é de 1 ano."
          >
            <P>Vencimento{reverse && 's'}</P>
            <SomaIcon icon="info" size="sm" color="#FFC709" />
          </SomaTooltip>

          {reverse ? (
            <DateRangePicker
              readOnly
              startDate={maturityDate}
              endDate={maturityDateReverse}
              showDefaultInputIcon={false}
              onDatesChange={onRangeDatesChange}
              isOutsideRange={day => disableDayBiggerOndeYear(day)}
            />
          ) : (
            <SingleDatePicker
              date={maturityDate}
              readOnly
              placeholder="Selecione"
              onChange={value => setMaturityDate(value)}
              isOutsideRange={day => disableDayBiggerOndeYear(day)}
            />
          )}
        </Col>

        <Button
          primary
          style={{ marginTop: '29px' }}
          disabled={!isFormHeaderValid}
          onClick={() => addStructure()}
          data-wa={waConfig.event.customQuotes.startQuote}
        >
          Iniciar Cotação
        </Button>
      </Row>
    </Container>
  );
}

export default Header;
